export default class CustomFieldPersist {
  name = '';

  projectId = '';

  static of(name: string, projectId: string) {
    const field = new CustomFieldPersist();
    field.name = name;
    field.projectId = projectId;
    return field;
  }
}
